import {Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {Master} from '../../../../../admin/models/master.interface';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-composition-chart',
  templateUrl: './composition-chart.component.html',
  styleUrls: ['./composition-chart.component.scss']
})
export class CompositionChartComponent implements OnInit {

  text = '';
  subtitle = '';
  data!: CountryChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  categories!: Master[];
  countryCategory!: string;
  dataCountries!: string[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('putonmarket')) {
      this.countryCategory = 'putonmarket';
      this.text = 'Put on market composition';
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    if (this.router.url.includes('collected')) {
      this.countryCategory = 'collected';
      this.text = 'Collected composition';
      this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', search.categoryType ? search.categoryType : 'NEW')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.subtitle = search.startYear + ' (tons)';
          this.dataCountries = [];
          this.kfChartsService.getComposition(search, this.countryCategory)
            .subscribe(response => {
              this.data = response;
              this.kfChartsService.getCompositionCountries(
                search, this.countryCategory).subscribe(response2 => this.dataCountries = response2);
            });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

  loadCategories(event: string): void {
    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', event)
      .subscribe(data => this.years = data);
  }

}
